export class RefreshTokenRequest {
  token?: string;
  refreshToken?: string;
  appVersion?: string;
}
